const NATURAL_WORDS = ['naturale', 'természetes', 'natürlich', 'prirodni', 'naravno', 'natural', 'natur', 'prah'];

export function stripNaturalWords(value: string): string {
  if (!value) return value;
  let result = value;
  for (const word of NATURAL_WORDS) {
    // consumes an optional surrounding "-" along with the word itself
    result = result.replace(new RegExp(`\\s*-?\\s*\\b${word}\\b\\s*-?\\s*`, 'gi'), ' ');
  }
  return result.replace(/\s{2,}/g, ' ').replace(/^-+\s*|\s*-+$/g, '').trim();
}

export function getMaterialDisplayName(name: string | undefined | null, colorName: string | null): string {
  if (!name) {
    return '';
  }
  if (!colorName) {
    return stripNaturalWords(name);
  }
  let base = name.replace(/\s*-.*$/, '').trimEnd();
  base = stripNaturalWords(base);
  return `${base} - ${colorName}`;
}